import React from "react";

interface OverlayProps {
  onClose: () => void;
}

export default function Overlay({ onClose }: OverlayProps) {
  return (
    <div className="overlay">
      <div className="overlay__message">
        🎉 You solved it! 🎉
        <button onClick={onClose} className="overlay__button">
          next trial
        </button>
      </div>
    </div>
  );
}
